varying vec3 vPositionW;
varying vec3 vNormalW;
varying vec2 vUv;

void main() {
  // vPositionW  = (modelMatrix * vec4(position, 1.0)).xyz;
  // vNormalW = normalize( mat3( modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz ) * normal );
  vUv = uv;

  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}